import { stringify } from 'query-string';
import { BASE_V2_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'PROGRAMS_GET',
  GET_SUCCESS: 'PROGRAMS_GET_SUCCESS',
  GET_FAILURE: 'PROGRAMS_GET_FAILURE',
  GET_ALL: 'PROGRAMS_GET_ALL',
  GET_ALL_SUCCESS: 'PROGRAMS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'PROGRAMS_GET_ALL_FAILURE',
  POST: 'PROGRAMS_POST',
  POST_SUCCESS: 'PROGRAMS_POST_SUCCESS',
  POST_FAILURE: 'PROGRAMS_POST_FAILURE',
  PATCH: 'PROGRAMS_PATCH',
  PATCH_SUCCESS: 'PROGRAMS_PATCH_SUCCESS',
  PATCH_FAILURE: 'PROGRAMS_PATCH_FAILURE',
  INVALIDATE_ITEM: 'PROGRAMS_INVALIDATE_ITEM',
  INVALIDATE_LIST: 'PROGRAMS_INVALIDATE_ALL',
};

export const get = actions.get(userId => `${BASE_V2_URL}/programs/${userId}/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const invalidateList = params => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_LIST,
    payload: { params },
  });
};

export const getAll = actions.getAll(
  query => `${BASE_V2_URL}/programs/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post((id, value) => `${BASE_V2_URL}/programs/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(programId => `${BASE_V2_URL}/programs/${programId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
